export const all_routes = {
  // Auth
  signin: "/signin",
  signup: "/signup",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  success: "/success",
  otp: "/otp",

  //Chat
  index: "/index",
  chat: "/chat",
  groupChat: "/group-chat",
  allCalls: "/all-calls",
  status: "/status",
  myStatus: "/my-status",
  userStatus: "/user-status",
  //Admin Pages
  dashboard: "/admin/index",

  //ui routes
  alert: "/admin/ui-alert",
  accordion: "/admin/ui-accordion",
  avatar: "/admin/ui-avatar",
  badges: "/admin/ui-badges",
  border: "/admin/ui-border",
  breadcrums: "/admin/ui-breadcrums",
  button: "/admin/ui-buttons",
  buttonGroup: "/admin/ui-button-group",
  cards: "/admin/ui-cards",
  carousel: "/admin/ui-carousel",
  colors: "/admin/ui-colors",
  dropdowns: "/admin/ui-dropdowns",
  grid: "/admin/ui-grid",
  images: "/admin/ui-images",
  lightbox: "/admin/ui-lightbox",
  media: "/admin/ui-media",
  modals: "/admin/ui-modals",
  navTabs: "/admin/ui-navtabs",
  offcanvas: "/admin/ui-offcanvas",
  pagination: "/admin/ui-pagination",
  placeholder: "/admin/ui-placeholder",
  popover: "/admin/ui-popover",
  progress: "/admin/ui-progress",
  rangeSlider: "/admin/ui-rangeslider",
  spinner: "/admin/ui-spinner",
  sweetalert: "/admin/sweetalert",
  toasts: "/admin/ui-toasts",
  tooltip: "/admin/ui-tooltip",
  typography: "/admin/ui-typography",
  video: "/admin/ui-video",
  clipboard: "/admin/ui-clipboard",
  counter: "/admin/ui-counter",
  dragandDrop: "/admin/ui-drag-drop",
  rating: "/admin/ui-rating",
  ribbon: "/admin/ui-ribbon",
  stickyNotes: "/admin/ui-sticky-notes",
  textEditor: "/admin/ui-text-editor",
  timeLine: "/admin/ui-timeline",
  scrollBar: "/admin/ui-scrollbar",
  apexChat: "/admin/ui-apexchat",
  chart: "/admin/ui-chartjs",
  featherIcons: "/admin/ui-feather-icon",
  falgIcons: "/admin/ui-flag-icon",
  fantawesome: "/admin/ui-fantawesome",
  materialIcon: "/admin/ui-material-icon",
  pe7icon: "/admin/ui-icon-pe7",
  simpleLineIcon: "/admin/ui-simpleline",
  themifyIcon: "/admin/ui-themify",
  typicon: "/admin/ui-typicon",
  weatherIcon: "/admin/ui-weather-icon",
  basicInput: "/admin/forms-basic-input",
  checkboxandRadion: "/admin/form-checkbox-radios",
  inputGroup: "/admin/form-input-groups",
  gridandGutters: "/admin/form-grid-gutters",
  formSelect: "/admin/form-select",
  formMask: "/admin/form-mask",
  fileUpload: "/admin/form-fileupload",
  horizontalForm: "/admin/form-horizontal",
  verticalForm: "/admin/form-vertical",
  floatingLable: "/admin/form-floating-labels",
  formValidation: "/admin/form-validation",
  reactSelect: "/admin/select",
  formWizard: "/admin/form-wizard",
  dataTable: "/admin/data-tables",
  tableBasic: "/admin/tables-basic",
  iconicIcon: "/admin/icon-ionic",

  //base-ui
  uiAlerts: "/admin/ui-alerts",
  uiAccordion: "/admin/ui-accordion",
  uiAvatar: "/admin/ui-avatar",
  uiBadges: "/admin/ui-badges",
  uiBorders: "/admin/ui-borders",
  uiButtons: "/admin/ui-buttons",
  uiButtonsGroup: "/admin/ui-buttons-group",
  uiBreadcrumb: "/admin/ui-breadcrumb",
  uiCards: "/admin/ui-cards",
  uiCarousel: "/admin/ui-carousel",
  uiColor: "/admin/ui-color",
  uiDropdowns: "/admin/ui-dropdowns",

  users: "/admin/users/user-list",
  blockuser: "/admin/users/block-user",
  reportuser: "/admin/users/report-user",
  inviteuser: "/admin/users/invite-user",
  group: "/admin/group",
  chats: "/admin/chat",
  calls: "/admin/call",
  abusemessage: "/admin/abuse-message",
  stories: "/admin/stories",
  profileSettings: "/admin/settings/profile-settings",
  Change_Password: "/admin/settings/change-password",
  notification_settings: "/admin/settings/notification-settings",
  companysettings: "/admin/settings/company-settings",
  AuthenticationSettings: "/admin/settings/authentication-settings",
  socialauth: "/admin/settings/social-auth",
  ChatSettings: "/admin/settings/chat-settings",
  video_audio_settings: "/admin/settings/video-audio-settings",
  custom_fields: "/admin/settings/custom-fields",
  integration: "/admin/settings/integrations",
  localization_settings: "/admin/settings/localization-settings",
  email_settings: "/admin/settings/email-settings",
  sms_settings: "/admin/settings/sms-settings",
  otp_settings: "/admin/settings/otp",
  LanguageSettings: "/admin/settings/language/index",
  add_LanguageSettings: "/admin/settings/add-language",
  language_web_settings: "/admin/settings/language-web",
  gdpr_settings: "/admin/settings/gdpr",
  AppearanceSettings: "/admin/settings/appearance-settings",
  storage_settings: "/admin/settings/storage",
  backup_settings: "/admin/settings/backup",
  clear_cache_settings: "/admin/settings/clear-cache",
  ban_address: "/admin/settings/ban-address",


  //Admin Auth
  login: "/admin/login",
  adminForgotPassword: "/admin/forgot-password",
  adminResetPassword: "/admin/reset-password",
  adminResetPasswordSuccess: "/admin/reset-password-success",
};
